import { combineReducers } from 'redux';

import loadbalancer from './loadbalancer/reducer';
import util from './util/utilReducer';
import zone from './zone/zoneReducer';

export default combineReducers({
	loadbalancer,
	util,
	zone,
});
